// Source: https://diamond-latest.dyn-des.vpsvc.com/v0/auto-layouts/products?requestor=AG

interface Products {
    product: {
        productId: string;
        productVersion: number;
        productOptions: Record<string, string>;
        viewingDistance: string;
        isFullyDecorated?: boolean;
        substrateType?: string;
    };
    useCases: string[];
}

export const AUTO_LAYOUT_PRODUCTS: Products[] = [
    {
        product: {
            productId: 'PRD-IYXT1T3V',
            productVersion: 52,
            productOptions: {
                Finish: 'None',
                Backsides: 'Blank',
                Shape: 'Standard',
                Corners: 'Standard Corners',
                Thickness: 'Standard',
                Substrate: 'Matte',
                'Product Orientation': 'Horizontal',
                'Connected Cards': 'None',
            },
            viewingDistance: 'hand',
        },
        useCases: [
            'Logo Only',
            'Composed-Logo',
            'Identity (Business)',
            'Identity (Business-Medium)',
            'Identity (Contact)',
            'Identity (Employee)',
            'Identity (Business + Employee)',
            'Identity (High-Impact)',
            'Identity (Business) + Appointment',
        ],
    },
    {
        product: {
            productId: 'PRD-ADZNM4LP',
            productVersion: 48,
            productOptions: {
                Shape: 'Rounded Rectangle',
                'Product Orientation': 'Horizontal',
                Finish: 'Glossy',
                Size: '2"x3.5"',
                Material: 'White Paper',
            },
            viewingDistance: 'table',
        },
        useCases: ['Logo Only', 'Composed-Logo'],
    },
    {
        product: {
            productId: 'PRD-VZFDERJK',
            productVersion: 15,
            productOptions: {
                'Sign Option': 'Retractable',
                Size: '8.5" x 12"',
            },
            viewingDistance: 'hand',
        },
        useCases: ['Logo Only', 'Composed-Logo'],
    },
    {
        product: {
            productId: 'PRD-XEHU3NESB',
            productVersion: 27,
            productOptions: {
                Backside: 'Blank',
                Size: '2XL',
                'Substrate Color': '#04080b',
            },
            viewingDistance: 'distant',
        },
        useCases: ['Logo Only', 'Composed-Logo'],
    },
    {
        product: {
            productId: 'PRD-HSKBMXYA',
            productVersion: 37,
            productOptions: {
                'Product Orientation': 'Vertical',
                Size: '8.5" X 11"',
                Substrates: 'Semi-Gloss',
                Lamination: 'No',
            },
            viewingDistance: 'distant',
        },
        useCases: ['Logo Only', 'Composed-Logo'],
    },
    {
        product: {
            productId: 'PRD-U5XQ7S1K',
            productVersion: 8,
            productOptions: {
                Size: 'Medium (9.4"x4.3"x12.2")',
                'Paper Stock': 'White kraft',
                Backside: 'Blank',
            },
            viewingDistance: 'distant',
        },
        useCases: ['Logo Only', 'Composed-Logo'],
    },
    {
        product: {
            productId: 'PRD-DF5PWTHC',
            productVersion: 70,
            productOptions: {
                Shape: 'Circle',
                'Product Orientation': 'Horizontal',
                Size: '3"x3"',
                Material: 'White Paper',
                Finish: 'Gloss',
                'White Layer': 'False',
                'Custom Width': '3',
                'Custom Height': '3',
                'Unwind Direction': 'Bottom of Copy',
            },
            viewingDistance: 'table',
        },
        useCases: ['Logo Only', 'Composed-Logo'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#e6e6e6',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#37363c',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#3a2462',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#75736a',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'medium',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#3b4054',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#9fb7cc',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#792f41',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#4b64b4',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#40462a',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#7a805c',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'medium',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#f688b6',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#a6907d',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'medium',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#a5193a',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#a3bbd7',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#f57a7b',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#F6E58D',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#51423e',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#545c63',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#f7b632',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#8b8a8e',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'medium',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#ee3b7e',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#7f97ad',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'medium',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#2EA85C',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#F3CFD7',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#a3ec77',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#d43544',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#ddcdc1',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#328dbb',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'dark',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#C1C2D0',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#f6863c',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'light',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
    {
        product: {
            productId: 'PRD-K0H5MYXVT',
            productVersion: 32,
            productOptions: {
                Size: 'M',
                Backside: 'Blank',
                'Substrate Color': '#8583c4',
            },
            viewingDistance: 'distant',
            isFullyDecorated: false,
            substrateType: 'medium',
        },
        useCases: ['PPAGAutoLayouts', 'PPAG (Single Text)', 'Logo Only', 'PPAGTextOnlyAutoLayouts'],
    },
];
